<template>
  <material-card
    v-if="showTank()"
    data-testId="material-card"
    color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          v-bind="{ title: getTitle(), text: getText() }"
          :key="componentKey"
          data-testId="material-card-2"
          color="dover-blue">
          <div>
            <v-flex
              v-if="features.weightsMeasuresLock"
              xs12
              md12
              text-xs-center>
              <h6
                data-testId="W_M"
                class="heading-6 text-uppercase red--text font-weight-bold">
                {{ $t('W&M') }}
              </h6>
            </v-flex>
            <v-flex
              xs12
              md12>
              <v-tabs
                data-testId="tabs"
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  data-testId="tab-Settings"
                  ripple>
                  {{ $t('Settings') }}
                  <v-icon>mdi-settings</v-icon>
                </v-tab>
                <v-tab-item
                  :key="0">
                  <MaglinkTankSettings
                    :tank="tankData"
                    :system-settings="systemSettings"
                    :site-info="siteInfo"
                    :tank-groups="tankGroups"
                    :options="options"
                    :key="componentKey"
                    :total-tanks="totalTanks"
                    :probe-detected="probeDetected"
                    :probe-detected-serials="probeDetectedSerials"
                    :probe-serials="probeSerials"
                    :features="features"
                    data-testId="MaglinkTankSettings"
                    @tankSaved="onTankSaved"
                    @measurementRefresh="onMeasurementRefresh"
                    @tankModeChange="onTankModeChange"
                    @floatChanged="onFloatChanged"
                    @productChanged="onProductChanged"
                    @probesDetected="onProbesDetected"
                    @deliveryAlgorithmChange="onDeliveryAlgorithmChange" />
                </v-tab-item>
                <v-tab
                  :key="1"
                  data-testId="tab-Thresholds"
                  ripple>
                  {{ $t('Thresholds') }}
                  <v-icon>mdi-tune</v-icon>
                </v-tab>
                <v-tab-item
                  :key="1">
                  <MaglinkTankThresholds
                    :tank="tankData"
                    :system-settings="systemSettings"
                    :options="options"
                    :key="componentKey"
                    data-testId="MaglinkTankThresholds"
                    @tankSaved="onTankSaved"/>
                </v-tab-item>
                <template>
                  <v-tab
                    :key="2"
                    data-testId="tab-Density"
                    ripple>
                    {{ $t('Density') }}
                    <v-icon>mdi-chart-bubble</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="2">
                    <MaglinkTankDensity
                      :tank="tankData"
                      :measurement="tankMeasurement"
                      :probe-detected="probeDetected"
                      :system-settings="systemSettings"
                      :options="options"
                      :key="componentKey"
                      :features="features"
                      data-testId="MaglinkTankDensity"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                </template>
                <template
                  v-if="isAEF">
                  <v-tab
                    :key="3"
                    data-testId="tab-AEF"
                    ripple>
                    {{ $t('AEF') }}
                    <v-icon>mdi-waves</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="3">
                    <MaglinkTankThresholdsAef
                      :tank="tankData"
                      :measurement="tankMeasurement"
                      :system-settings="systemSettings"
                      :options="options"
                      :key="componentKey"
                      :features="features"
                      data-testId="MaglinkTankThresholdsAef"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                </template>
                <v-tab
                  :key="4"
                  data-testId="tab-Relays"
                  ripple>
                  {{ $t('Relays') }}
                  <v-icon>mdi-chip</v-icon>
                </v-tab>
                <v-tab-item
                  :key="4">
                  <MaglinkTankRelay
                    :tank="tankData"
                    :relays="tankData.relays"
                    :system-settings="systemSettings"
                    :site-info="siteInfo"
                    :options="options"
                    :key="componentKey"
                    :is-plus="isPlus"
                    data-testId="MaglinkTankRelay"
                    @tankRelaysSaved="onTankRelaysSaved"/>
                </v-tab-item>
                <v-tab
                  :key="5"
                  data-testId="tab-Straptable"
                  ripple
                  @click="doShowStrapTable()">
                  {{ $t('Straptable') }}
                  <v-icon>mdi-note-text</v-icon>
                </v-tab>
                <v-tab-item
                  :key="5">
                  <MaglinkTankStrapTable
                    :tank="tankData"
                    :tanks="tankListData"
                    :system-settings="systemSettings"
                    :options="options"
                    :key="componentKey"
                    :show-strap-table="showStrap"
                    :features="features"
                    data-testId="MaglinkTankStrapTable"
                    @tankStrapSaved="onTankStrapSaved"
                    @tankStrapCopied="onTankStrapCopied"/>
                </v-tab-item>
                <template
                  v-if="isLeakManageable">
                  <v-tab
                    :key="6"
                    data-testId="tab-Leak-test"
                    ripple>
                    {{ $t('Leak test') }}
                    <v-icon>mdi-water</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="6">
                    <MaglinkTankScheduledLeakTest
                      :tank="tankData"
                      :scheduled-leak-test="scheduledLeakTest"
                      :system-settings="systemSettings"
                      :site-info="siteInfo"
                      :options="options"
                      :key="componentKey"
                      :probe-detected="probeDetected"
                      data-testId="MaglinkTankScheduledLeakTest"
                      @scheduledLeakTestSaved="onScheduledLeakTestSaved"
                      @scheduledLeakTestDeleted="onScheduledLeakTestDeleted"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                </template>
                <template
                  v-if="acrMode">
                  <v-tab
                    :key="7"
                    data-testId="tab-ACR-mode"
                    ripple>
                    {{ $t('ACR mode') }}
                    <v-icon>mdi-auto-upload</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="7">
                    <MaglinkTankSettingsAcr
                      :tank="tankData"
                      :system-settings="systemSettings"
                      :options="options"
                      :key="componentKey"
                      :features="features"
                      data-testId="MaglinkTankSettingsAcr"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                  <v-tab
                    :key="8"
                    data-testId="tab-ACR-results"
                    ripple>
                    {{ $t('ACR results') }}
                    <v-icon>mdi-playlist-check</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="8">
                    <MaglinkTankSettingsAcrResults
                      :tank="tankData"
                      :system-settings="systemSettings"
                      :options="options"
                      :key="componentKey"
                      :features="features"
                      data-testId="MaglinkTankSettingsAcrResults"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                  <v-tab
                    :key="9"
                    data-testId="tab-Reconciliation"
                    ripple>
                    {{ $t('Reconciliation') }}
                    <v-icon>mdi-sync</v-icon>
                  </v-tab>
                  <v-tab-item
                    :key="9">
                    <MaglinkTankSettingsReconciliation
                      :tank="tankData"
                      :system-settings="systemSettings"
                      :options="options"
                      :key="componentKey"
                      data-testId="MaglinkTankSettingsReconciliation"
                      @tankSaved="onTankSaved"/>
                  </v-tab-item>
                </template>
              </v-tabs>
            </v-flex>
          </div>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>
export default {
  props: {
    tankData: {
      type: Object,
      required: false,
      default: () => {}
    },
    tankListData: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    tankGroups: {
      type: Array,
      required: true,
      default: () => []
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    componentKey: {
      type: Number,
      required: true,
      default: () => 0
    },
    currentKey: {
      type: Number,
      required: true,
      default: () => 0
    },
    totalTanks: {
      type: Number,
      required: true,
      default: () => 0
    },
    scheduledLeakTest: {
      type: Object,
      required: true,
      default: () => {}
    },
    features: {
      type: Object,
      required: true,
      default: () => {}
    },
    probeDetected: {
      type: Array,
      required: true,
      default: () => []
    },
    probeDetectedSerials: {
      type: Array,
      required: true,
      default: () => []
    },
    isPlus: {
      type: Boolean,
      required: true,
      default: () => false
    }
  },
  data: () => ({
    keepShowing: false,
    showStrap: false,
    acrMode: false,
    isAEF: false,
    probeSerials: [],
    tankMeasurement: {}
  }),
  computed: {
    isLeakManageable () {
      return this.tankData.probeType !== 16
    }
  },
  mounted () {
    this.tankMeasurement = this.tankData.lastMeasurement
    this.tankListData.forEach(item => {
      this.probeSerials.push({ tank: item.tankNumber, serial: item.serial })
    })

    this.acrMode = this.tankData.autoCalibrationEnabled
    this.isAEF = this.isAEFFloat()
  },
  methods: {
    showTank () {
      // if was already displayed before
      if (this.keepShowing) return true
      // if the first time i'm clicking this tank
      if (this.currentKey === this.tankData.tankNumber) {
        this.keepShowing = true
      }
      return this.keepShowing
    },
    doShowStrapTable () {
      this.showStrap = true
    },
    getText () {
      let result = this.$t('Height') + ' (' + this.Maglink.LevelFormat(this.tankData.maxLevel, this.systemSettings.levelUnit) + ')'
      result += ' ' + this.options.levelUnits[this.systemSettings.levelUnit || 0].desc + ' - '
      result += this.$t('Max volume') + ' (' + this.Maglink.VolumeFormat(this.tankData.maxVolume, this.systemSettings.volumeUnit) + ')'
      result += ' ' + this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

      return result
    },
    getTitle () {
      let result = this.tankData.tankDescription
      if (result === undefined) {
        result = this.$t('Tank {0}', [this.tankData.tankNumber])
      }
      result += ' (' + this.$t('Serial: {0}', [this.tankData.serial]) + ')'

      return result
    },
    onTankSaved (tankNumber) {
      this.$emit('tankSaved', tankNumber)
      this.isAEF = this.isAEFFloat()
    },
    onTankModeChange (tankNumber, acrMode) {
      this.acrMode = acrMode
    },
    onTankRelaysSaved (tankNumber) {
      this.$emit('tankRelaysSaved', tankNumber)
    },
    onTankStrapSaved (tankNumber) {
      this.$emit('tankStrapSaved', tankNumber)
    },
    onTankStrapCopied (tankNumber) {
      this.$emit('tankStrapCopied', tankNumber)
    },
    onScheduledLeakTestSaved (tankNumber) {
      this.$emit('scheduledLeakTestSaved', tankNumber)
    },
    onScheduledLeakTestDeleted (tankNumber) {
      this.$emit('scheduledLeakTestDeleted', tankNumber)
    },
    onDeliveryAlgorithmChange (deliveryAlgorithm) {
      this.$emit('siteInfoSaved', this.siteInfo)
    },
    onFloatChanged (tankNumber) {
      this.isAEF = this.isAEFFloat()
      this.componentKey += 1
    },
    onProductChanged (tankNumber, productFamily) {
      if (this.currentKey !== tankNumber) {
        return
      }
      this.tankData.productFamily = productFamily
      let found = this.Maglink.Products.find(r => r.code === productFamily) || -1
      if (found !== -1) {
        if ((this.tankData.densityCompManual < 0.01 && this.systemSettings.volumeUnit === 1) || this.Maglink.isApiDegree(this.tankData.densityCompManual)) {
          this.tankData.densityCompManual = this.Maglink.RoundFormat(this.Maglink.toApiDegree(found.baseDensity), 1)
        } else {
          this.tankData.densityCompManual = found.baseDensity
        }
      }
      this.componentKey += 1
    },
    onMeasurementRefresh (tankNumber) {
      if (this.currentKey !== tankNumber) {
        return
      }
      this.Maglink.GetTankStatus(tankNumber)
        .then(response => {
          // response.data
          this.tankMeasurement = this.Maglink.ToDisplay(response.data.lastMeasurement, this.systemSettings.levelUnit, this.systemSettings.volumeUnit, this.systemSettings.temperatureUnit)
        })
    },
    onProbesDetected (probes, probeSerials) {
      this.probeDetected = probes
      this.probeDetectedSerials = probeSerials
    },

    isAEFFloat () {
      return this.tankData.probeWaterFloat === 2
    },
    snack (color, message) {
      message = this.$t('Tanks setup') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
